(function EHJS(){
  var EH=window.EH||{};
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function fmt(c){var f=EH.money||'₹{{amount}}',v=c/100;return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
    if(k==='amount_no_decimals')return Math.round(v).toLocaleString('en-IN');
    if(k==='amount_with_comma_separator')return v.toFixed(2).replace('.',',');
    if(k==='amount_no_decimals_with_comma_separator')return Math.round(v).toLocaleString('de-DE');
    return v%1?v.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2}):v.toLocaleString('en-IN');}).replace(/<[^>]+>/g,'')}
  var drawer=$('[data-eh-drawer]');
  function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
  function render(cart){
    $$('[data-cart-count]').forEach(function(e){e.textContent=cart.item_count});
    if(!drawer)return;
    var box=$('[data-drawer-items]',drawer);
    box.innerHTML=cart.items.length?cart.items.map(function(it,i){
      var img=it.image?it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=200':'';
      var vt=it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:'';
      return '<div class="eh-line">'+(img?'<img src="'+esc(img)+'" alt="">':'<span></span>')+
        '<div class="eh-line__t"><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+(vt?'<small>'+esc(vt)+'</small>':'')+
        '<div class="eh-line__q"><button type="button" data-line="'+(i+1)+'" data-line-q="'+(it.quantity-1)+'" aria-label="Less">−</button>'+it.quantity+
        '<button type="button" data-line="'+(i+1)+'" data-line-q="'+(it.quantity+1)+'" aria-label="More">+</button></div></div>'+
        '<span style="font:500 15px/1 var(--sans)">'+fmt(it.final_line_price)+'</span></div>';
    }).join(''):'<p class="eh-body" style="padding:28px 0">Your bag is empty.</p>';
    var sub=$('[data-subtotal]',drawer);if(sub)sub.textContent=fmt(cart.total_price);
    var fl=$('[data-free-line]',drawer),fb=$('[data-free-bar]',drawer);
    if(fl&&EH.free>0){var left=EH.free-cart.total_price;
      fl.textContent=cart.item_count===0?'Free delivery from '+fmt(EH.free)+'.':left>0?fmt(left)+' away from free delivery.':'Free delivery on this order.';
      fb.style.width=Math.min(100,Math.round(cart.total_price/EH.free*100))+'%';}
  }
  function open(){if(!drawer){location.href='/cart';return}drawer.classList.add('is-open');document.body.style.overflow='hidden'}
  function close(){if(!drawer)return;drawer.classList.remove('is-open');document.body.style.overflow=''}
  function add(items){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(getCart).then(function(c){render(c);open()})
      .catch(function(e){alert((e&&(e.description||e.message))||'Could not add to bag.')});
  }
  document.addEventListener('submit',function(e){
    var f=e.target.closest&&e.target.closest('form.eh-ajax');if(!f)return;e.preventDefault();
    var fd=new FormData(f);add([{id:+fd.get('id'),quantity:+(fd.get('quantity')||1)}]);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  document.addEventListener('change',function(e){
    if(e.target.matches('[data-sort]')){var u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);location.href=u.toString()}
  });
  document.addEventListener('click',function(e){
    var t=e.target;if(!t.closest)return;var x;
    if((x=t.closest('[data-open-cart]'))&&drawer){e.preventDefault();getCart().then(function(c){render(c);open()});return}
    if(t.closest('[data-close-cart]')){close();return}
    if((x=t.closest('[data-add-ids]'))){e.preventDefault();add(x.dataset.addIds.split(',').filter(Boolean).map(function(id){return {id:+id,quantity:1}}));return}
    if((x=t.closest('[data-line-q]'))){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:+x.dataset.line,quantity:+x.dataset.lineQ})}).then(function(r){return r.json()}).then(render);return}
    if((x=t.closest('[data-close-details]'))){var d=x.closest('details');if(d)d.open=false;return}
    if((x=t.closest('[data-swatch]'))){
      e.preventDefault();var sc=x.closest('[data-swatch-scope]');if(!sc)return;
      $$('[data-swatch]',sc).forEach(function(b){b.setAttribute('aria-pressed',b===x)});
      var img=$('[data-swatch-target] img',sc);
      if(img&&x.dataset.img){img.removeAttribute('srcset');img.src=x.dataset.img;sc.classList.add('is-picked')}
      var lb=$('[data-swatch-label]',sc);if(lb)lb.textContent=x.dataset.name;
      var inp=$('input[name="id"]',sc);if(inp&&x.dataset.vid)inp.value=x.dataset.vid;
      if(x.dataset.url)$$('[data-swatch-link]',sc).forEach(function(a){a.href=x.dataset.url});
      return}
    if((x=t.closest('[data-room-pick]'))){var rm=x.closest('[data-room]'),i=x.dataset.roomPick;
      $$('[data-room-pick]',rm).forEach(function(b){b.setAttribute('aria-pressed',b===x)});
      $$('[data-room-panel]',rm).forEach(function(p){p.hidden=p.dataset.roomPanel!==i});return}
    if((x=t.closest('[data-mode]'))){var w=x.closest('.eh-gallery-wrap'),m=x.dataset.mode,first=true;
      $$('[data-mode]',w).forEach(function(b){b.setAttribute('aria-pressed',b===x)});
      $$('[data-kind]',w).forEach(function(it){var on=it.dataset.kind===m;it.hidden=!on;it.classList.toggle('is-lead',on&&first);if(on)first=false});return}
    if((x=t.closest('[data-open-acc]'))){var a=$('[data-acc="'+x.dataset.openAcc+'"]');if(a){a.open=true;window.scrollTo({top:a.getBoundingClientRect().top+scrollY-100,behavior:'smooth'})}return}
    if((x=t.closest('[data-qty]'))){var q=x.parentNode.querySelector('input');q.value=Math.max(1,Math.min(20,(+q.value||1)+(+x.dataset.qty)));q.dispatchEvent(new Event('input',{bubbles:true}));return}
    if((x=t.closest('button[data-opt]'))){var root=x.closest('[data-pdp]');
      $$('[data-opt="'+x.dataset.opt+'"]',root).forEach(function(b){b.setAttribute('aria-pressed',b===x)});
      if(root._apply)root._apply();return}
    if((x=t.closest('[data-pin-check]'))){checkPin(x.closest('[data-pdp]'));return}
  });
  function checkPin(root){
    if(!root)return;var i=$('[data-pin]',root),o=$('[data-pin-out]',root);if(!i||!o)return;
    var p=i.value.replace(/\D/g,'').slice(0,6);i.value=p;
    if(!/^\d{6}$/.test(p)){o.textContent='Enter a 6-digit PIN code.';return}
    try{localStorage.setItem('eh-pin',p)}catch(err){}
    var d=new Date();d.setDate(d.getDate()+(+root.dataset.days||0));
    var ds=d.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'});
    o.innerHTML='Estimated delivery by <b style="font-weight:500">'+ds+'</b> to '+p+'.';
    var sl=$('[data-sticky-del]',root);if(sl)sl.textContent=' · by '+ds;
  }
  function initPDP(root){
    var js=$('[data-pdp-json]',root);if(!js)return;var data=JSON.parse(js.textContent);
    var input=$('[data-variant-input]',root),qi=$('[data-qty-input]',root);
    function sel(){var o=[];$$('[data-opt][aria-pressed="true"]',root).forEach(function(b){o[+b.dataset.opt]=b.dataset.value});return o}
    function find(){var s=sel();return data.variants.find(function(v){return v.options.every(function(o,i){return s[i]===undefined||o===s[i]})})}
    function apply(v,init){
      var add=$('[data-main-add]',root),st=$('[data-sticky-add]',root);
      if(!v){if(add){add.disabled=true;add.textContent='Unavailable'}return}
      input.value=v.id;var q=+(qi&&qi.value||1);
      $$('[data-price]',root).forEach(function(e){e.textContent=fmt(v.price)});
      if(add){add.disabled=!v.available;add.textContent=v.available?'Add to bag · '+fmt(v.price*q):'Sold out'}
      if(st)st.disabled=!v.available;
      v.options.forEach(function(o,i){var l=$('[data-opt-label="'+i+'"]',root);if(l)l.textContent=o});
      var sl=$('[data-sticky-line]',root);if(sl&&v.title!=='Default Title')sl.textContent=v.title;
      var fm=v.featured_media,src=(fm&&fm.preview_image&&fm.preview_image.src)||(v.featured_image&&v.featured_image.src);
      if(src&&!init){var lead=$('.eh-gallery__item.is-lead img',root);if(lead){lead.removeAttribute('srcset');lead.src=src+(src.indexOf('?')>-1?'&':'?')+'width=1800'}}
      if(!init){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString())}
    }
    root._apply=function(){apply(find())};
    apply(find(),true);
    if(qi)qi.addEventListener('input',root._apply);
    var main=$('[data-main-add]',root),sticky=$('[data-sticky]',root);
    if(main&&sticky&&'IntersectionObserver' in window){new IntersectionObserver(function(en){var e=en[0];sticky.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)}).observe(main)}
    var pi=$('[data-pin]',root);
    if(pi){pi.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();checkPin(root)}});
      try{var sv=localStorage.getItem('eh-pin');if(sv){pi.value=sv;checkPin(root)}}catch(err){}}
  }
  function initRail(){
    var rail=$('[data-rail]'),ch=$$('[data-chapter]');if(!rail||!ch.length)return;
    var list=$('[data-rail-list]',rail),fill=$('.eh-rail__fill',rail);
    ch.forEach(function(c,i){var a=document.createElement('a');a.href='#'+c.id;
      var n=document.createElement('span');n.className='eh-mono';n.textContent=c.dataset.num||('0'+(i+1));
      var b=document.createElement('b');b.textContent=c.dataset.name||'';
      var s=document.createElement('small');s.textContent=c.dataset.q||'';
      a.appendChild(n);a.appendChild(b);a.appendChild(s);list.appendChild(a)});
    var links=$$('a',list);
    function on(){var mid=innerHeight*.45,act=0;ch.forEach(function(c,i){if(c.getBoundingClientRect().top<mid)act=i});
      links.forEach(function(l,i){l.classList.toggle('is-on',i===act);l.classList.toggle('is-past',i<act)});
      var f=ch[0].getBoundingClientRect(),l=ch[ch.length-1].getBoundingClientRect();
      rail.classList.toggle('is-on',f.top<innerHeight*.6&&l.bottom>innerHeight*.4);
      fill.style.height=(Math.max(0,Math.min(1,(mid-f.top)/(l.bottom-f.top)))*100)+'%'}
    addEventListener('scroll',on,{passive:true});on();
  }
  $$('[data-pdp]').forEach(initPDP);
  initRail();
})();
(function DOOR(){
  var sec=document.querySelector('[data-door]');if(!sec)return;
  var q=function(s){return sec.querySelector(s)};
  var st=q('.eh-door__stage'),room=q('[data-d-room]'),leaf=q('[data-d-leaf]'),spill=q('[data-d-spill]'),floor=q('[data-d-floor]'),time=q('[data-d-time]'),copy=q('[data-d-copy]'),cap=q('[data-d-cap]'),img=q('[data-d-img] img, [data-d-img] svg');
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches,opened=false,raf=0;
  function ease(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2}
  function draw(){raf=0;
    var vw=st.clientWidth,vh=st.clientHeight,mob=innerWidth<750,r=sec.getBoundingClientRect(),span=r.height-innerHeight;
    var p=(mob||span<=0)?0:Math.min(1,Math.max(0,-r.top/span));if(reduce&&!mob)p=p>.3?1:0;
    var k=ease(Math.min(1,p/.85)),L=function(a,b){return a+(b-a)*k};
    var hdr=mob?0:Math.max(0,sec.offsetTop),V=mob?vh:vh-hdr,fl,t0,h0,w0,l0;
    if(mob){fl=Math.round(vh*.78);t0=Math.round(vh*.16);h0=fl-t0;w0=vw*.4;l0=vw*.5}
    else{fl=Math.round(V-Math.max(56,vh*.09));t0=44;h0=fl-t0;w0=Math.min(vw*.3,h0*.5);l0=vw-w0-Math.max(40,vw*.12)}
    var fade=Math.max(0,1-p*2.6),o=opened?1:0;
    var box='left:'+L(l0,0)+'px;top:'+L(t0,0)+'px;width:'+L(w0,vw)+'px;height:'+L(h0,vh)+'px;';
    room.style.cssText=box+(o?'box-shadow:0 0 0 1px #CFC6B8,-30px 0 120px -10px rgba(255,186,118,'+(.45*fade).toFixed(2)+')':'');
    leaf.style.cssText=box+'transform:rotateY('+(o?-76:0)+'deg);opacity:'+Math.max(0,1-p*4);
    floor.style.cssText='top:'+fl+'px;opacity:'+fade;
    var sw=w0+vw*.4,a=(vw*.2)/sw*100,b=(vw*.2+w0)/sw*100;
    spill.style.cssText='left:'+(l0-vw*.2)+'px;top:'+fl+'px;width:'+sw+'px;height:'+(vh-fl)+'px;clip-path:polygon('+a+'% 0,'+b+'% 0,100% 100%,0 100%);opacity:'+(o*fade);
    time.style.cssText='left:'+l0+'px;top:'+(fl+14)+'px;opacity:'+fade;
    copy.style.cssText=(mob?'':'bottom:'+(vh-fl+32)+'px;')+'opacity:'+fade+';transform:translateY('+(-p*80)+'px)';
    if(img)img.style.transform='scale('+(1.15-.15*k)+')';
    if(cap)cap.style.opacity=Math.max(0,Math.min(1,(p-.8)*5));
  }
  function req(){if(!raf)raf=requestAnimationFrame(draw)}
  addEventListener('scroll',req,{passive:true});addEventListener('resize',req);draw();
  setTimeout(function(){opened=true;draw()},reduce?0:300);
})();
